var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 21.6667V12.3333H7.33329V21.6667H4.66663ZM12.6666 21.6667V12.3333H15.3333V21.6667H12.6666ZM0.666626 9.66668V7.00001L14 0.333344L27.3333 7.00001V9.66668H0.666626ZM0.666626 27V24.3333H16.7333C16.7777 24.8 16.8333 25.25 16.9 25.6833C16.9666 26.1167 17.0666 26.5556 17.2 27H0.666626ZM20.6666 16.6667V12.3333H23.3333V15.3333L20.6666 16.6667ZM24.6666 31C23.1333 30.6222 21.8611 29.7389 20.85 28.35C19.8388 26.9611 19.3333 25.4222 19.3333 23.7333V20.3333L24.6666 17.6667L30 20.3333V23.7333C30 25.4222 29.4944 26.9611 28.4833 28.35C27.4722 29.7389 26.2 30.6222 24.6666 31ZM23.7 27L28.3333 22.4L26.9333 21L23.7 24.1667L22.4 22.8667L21 24.3L23.7 27Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.24fffeca1d0e416b426e2d3b1b9db282.svg";
export { ForwardRef as ReactComponent };